import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0fdbff20&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=0fdbff20&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports